import React, { useState } from 'react';

const policyContent = [
  {
    title: 'Accuracy of Information:',
    text: 'You are kindly requested to ensure that all information provided during registration, including business details, contact information, and media, is accurate and up to date.'
  },
  {
    title: 'Content Standards:',
    text: 'All content, including images, descriptions, and listings, must be appropriate for a general audience and not violate any local laws or regulations. Prohibited content includes, but is not limited to, fraudulent, illegal, offensive, or copyrighted material without proper authorization.'
  },
  {
    title: 'Subscription and Payment:',
    text: 'Your stall is activated upon successful payment of the subscription fee. The subscription is valid for a period paid for i.e 1 month, 6 months and 12 months. Renewal is required to maintain your stall\'s active status.'
  },
  {
    title: 'Standard Package:',
    text: 'When you pay for advertising space, please note that you will be given a maximum of 20 Images (Item photos or general business photos) and a maximum of 3 videos (not exceeding 50MBs & 1 minute per video). You can change/update your adverts anytime you want if your subscription is still due.'
  },
  {
    title: 'Premium Package:',
    text: 'When you pay for Premium advertising space, please note that you will be given a maximum of 30 Images (Item photos or general business photos) and a maximum of 10 videos (not exceeding 50MBs & 1 minute per video). Premium adverts will also appear on the front page of the website and will keep reshuffling. You can change/update your adverts anytime you want if your subscription is still due.'
  },
  {
    title: 'Termination:',
    text: 'Grema reserves the right to suspend or terminate any stall registration without refund if the user violates these terms and conditions.'
  },
  {
    title: 'Liability:',
    text: 'Regarding the advertising arm, Grema is a platform for advertising and connecting businesses and customers. We are not responsible for any transactions, disputes, or liabilities arising between business owners and customers.'
  },
  {
    title: 'Business verification:',
    text: 'Please note that GREMA will physically verify your business either remotely or physically through its field staff. This is to ensure that your business is genuine and also to help GREMA be able to direct customers to access your business and services easily.'
  },
  {
    title: 'Exceptions on Specific Advertisements:',
    text: 'To protect customers from fraudulent opportunists, GREMA requires advertisers of Cars, Land and all forms of buildings to provide Logbooks, land titles and photocopies of national IDs/Passports bearing respective actual names of advertisers. This information is for GREMA verification purposes only and not for public consumption. Also, for this category of property, business owners will only advertise one item per subscription. gremaglobal.com will also not advertise products that are illegal in respective governments. Please ensure that you advertise products and services within the legal frameworks of your respective governments.'
  },
];

const PolicyPage = () => {
  const [showConsentMessage, setShowConsentMessage] = useState(false);

  const handleAgreeClick = () => {
    setShowConsentMessage(true);
  };

  return (
    <>
      <style>
        {`
          .policy-container {
            max-width: 1000px;
            margin: 0 auto;
            padding: 40px 20px;
            font-family: 'Inter', sans-serif;
            color: #1a202c;
            line-height: 1.8;
            background-color: #f7fafc;
            border-radius: 16px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          }
          @media (max-width: 768px) {
            .policy-container {
              padding: 20px 15px;
            }
          }
          .header {
            text-align: center;
            font-size: 3rem;
            font-weight: 700;
            color: #2c5282;
            margin-bottom: 20px;
            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.05);
          }
          @media (max-width: 768px) {
            .header {
              font-size: 2.5rem;
            }
          }
          .policy-list {
            list-style: none;
            padding: 0;
          }
          .policy-item {
            background-color: #fff;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 25px;
            margin-bottom: 20px;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .policy-item:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          }
          .policy-title {
            font-size: 1.3rem;
            font-weight: 600;
            color: #2c5282;
            margin-bottom: 10px;
          }
          .policy-text {
            font-size: 1rem;
            color: #4a5568;
            line-height: 1.6;
          }
          .policy-text strong {
            color: #1a202c;
          }
          .note-container {
            background-color: #ebf8ff;
            border-left: 5px solid #4299e1;
            padding: 20px;
            margin-top: 40px;
            border-radius: 8px;
          }
          .note-title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #2b6cb0;
            margin-bottom: 10px;
          }
          .note-text {
            font-size: 1rem;
            color: #4c6b8b;
            line-height: 1.6;
          }
          .note-text strong {
            color: #2b6cb0;
          }
          .consent-section {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 40px;
          }
          .consent-button {
            padding: 12px 24px;
            font-size: 1.1rem;
            font-weight: 600;
            color: #fff;
            background-color: #38b2ac;
            border: none;
            border-radius: 9999px;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.1s ease;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }
          .consent-button:hover {
            background-color: #319795;
            transform: translateY(-2px);
          }
          .consent-message {
            margin-top: 20px;
            font-size: 1rem;
            font-weight: 500;
            color: #4a5568;
            text-align: center;
          }
        `}
      </style>
      <div className="policy-container">
        <h1 className="header">Our Policy</h1>
        <div className="policy-list">
          {policyContent.map((item, index) => (
            <div className="policy-item" key={index}>
              <h3 className="policy-title">{item.title}</h3>
              <p className="policy-text">{item.text}</p>
            </div>
          ))}
        </div>
        <div className="note-container">
          <h3 className="note-title">NB: Customer safety precautionary measures</h3>
          <p className="note-text">
            Much as GREMA will verify businesses, customers are <strong>STRONGLY advised</strong> to ensure they meet sellers and dealers in safe open places especially where services are in different locations (for Land, Cars and other properties dealings). It is still your responsibility to ensure you are free from fraud or harmful eventualities related to any transactions.
          </p>
        </div>
        {/* <div className="consent-section">
          <button className="consent-button" onClick={handleAgreeClick}>
            I Agree
          </button>
          {showConsentMessage && (
            <p className="consent-message">You have agreed to our terms and conditions.</p>
          )}
        </div> */}
      </div>
    </>
  );
};

export default PolicyPage;
export {};
